import { render, staticRenderFns } from "./view-scheme-details.vue?vue&type=template&id=6c7b4d6e"
import script from "./view-scheme-details.vue?vue&type=script&lang=js"
export * from "./view-scheme-details.vue?vue&type=script&lang=js"
import style0 from "./view-scheme-details.vue?vue&type=style&index=0&id=6c7b4d6e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports